/* Translate this spec gibberish — cool-uncle voice, every category.
   Drop-in replacement for assets/translate-gibberish.js.

   Routes by category based on the spec card keys present in the DOM:
     TV          screen size + resolution + display + refresh + hdr + platform
     Monitor     panel size + resolution + refresh rate + panel type
     Headphone   form factor + anc + battery + connectivity
     Soundbar    channels + hdmi + atmos + subwoofer
     HomeTheater channels + total power + atmos + hdmi
     Projector   brightness + resolution + throw + light source
     Camera      megapixels + sensor + max video + lens mount
     Kitchen     capacity + wattage + (presets|max temp|brew styles|speeds|sensor cooking|finish|attachments)
*/
(function(){
  function N(v){var m=String(v||'').match(/(\d+)/);return m?parseInt(m[1],10):0}
  function I(s,q){return s.indexOf(q)>-1}
  function has(o,k){return Object.prototype.hasOwnProperty.call(o,k)&&o[k]!=null&&o[k]!==''}
  function pick(a){return a[Math.floor(Math.random()*a.length)]}
  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}

  function readSpecs(gridId){
    var g=document.getElementById(gridId);if(!g)return{};
    var o={};
    g.querySelectorAll('.pdp__spec-card').forEach(function(c){
      var k=c.querySelector('.pdp__spec-key'),v=c.querySelector('.pdp__spec-val');
      if(!k||!v)return;
      var x=v.cloneNode(!0),u='';
      x.querySelectorAll('.pdp__spec-unit').forEach(function(e){u+=' '+e.textContent.trim();e.remove()});
      o[k.textContent.trim().toLowerCase()]=(x.textContent.trim()+u).replace(/\s+/g,' ').trim();
    });
    return o;
  }

  // ───────────────────────── CATEGORY DETECTION ─────────────────────────

  function detectCategory(s){
    if (has(s,'form factor') || has(s,'anc') || has(s,'battery') || has(s,'battery life')) return 'headphone';
    if (has(s,'channels')||has(s,'audio channels')) {
      if (has(s,'total power')) return 'home_theater';
      if (has(s,'subwoofer')) return 'soundbar';
      return 'soundbar';
    }
    if (has(s,'brightness') || has(s,'throw') || has(s,'throw type') || has(s,'light source')) return 'projector';
    if (has(s,'megapixels') || has(s,'sensor') || has(s,'sensor size') || has(s,'lens mount') || has(s,'mount')) return 'camera';
    if (has(s,'capacity')) {
      if (has(s,'max temp')) return 'air_fryer';
      if (has(s,'brew styles')) return 'coffee_maker';
      if (has(s,'finish') && has(s,'ice maker')) return 'refrigerator';
      if (has(s,'sensor cooking')) return 'microwave';
      if (has(s,'attachments')) return 'stand_mixer';
      if (has(s,'speeds') && has(s,'wattage')) return 'blender';
      if (has(s,'wattage')) return 'kitchen';
    }
    if (has(s,'panel size') || has(s,'response time')) return 'monitor';
    return 'tv';
  }

  // ───────────────────────── SHARED ─────────────────────────

  var SIGNOFFS=[
    "Now go tell your spouse you did your research.",
    "Spec sheet, slain.",
    "Alright kid, you've got the intel. Godspeed.",
    "You're welcome — back to the game.",
    "Now go pretend you knew this already.",
    "If it breaks, you didn't hear it from me.",
    "Trust your uncle on this one.",
    "Consider yourself briefed.",
    "Go forth and binge responsibly.",
    "You're dangerous now. Use it wisely.",
    "Pull the trigger before your tab closes."
  ];

  // Hard caps so the panel never exceeds a comfortable height — must fit in
  // the spec-card area (~420px) without clipping or scrolling off-page.
  var MAX_PROS = 4;
  var MAX_CONS = 1;
  // Cap any single bullet at ~95 chars — uncle voice is punchy, not verbose.
  // Verdict gets a slightly bigger budget (130) since it's a single line.
  function trim(t, max){
    t = String(t||'').trim();
    var m = max || 95;
    if (t.length <= m) return t;
    var cut = t.lastIndexOf(' ', m - 3);
    return t.slice(0, cut > 0 ? cut : m - 3).replace(/[,;:.\-—]+$/,'') + '\u2026';
  }

  function shell(verdict,pros,cons,who,signoff){
    pros = (pros||[]).slice(0, MAX_PROS).map(function(t){return trim(t, 95);});
    cons = (cons||[]).slice(0, MAX_CONS).map(function(t){return trim(t, 95);});
    verdict = trim(verdict, 130);

    var html='<div class="pdp__translate-v2__verdict"><span class="pdp__translate-v2__verdict-label">Uncle\u2019s take</span>'+esc(verdict)+'</div>';
    if(pros.length){
      html+='<div class="pdp__translate-v2__section"><div class="pdp__translate-v2__section-title">The good stuff</div><ul class="pdp__translate-v2__list pdp__translate-v2__list--pros">';
      pros.forEach(function(p){html+='<li>'+p+'</li>'});
      html+='</ul></div>';
    }
    if(cons.length){
      html+='<div class="pdp__translate-v2__section"><div class="pdp__translate-v2__section-title">Watch-outs</div><ul class="pdp__translate-v2__list pdp__translate-v2__list--cons">';
      cons.forEach(function(p){html+='<li>'+p+'</li>'});
      html+='</ul></div>';
    }
    html+='<p class="pdp__translate-v2__who">'+who+'</p>';
    html+='<p class="pdp__translate-v2__signoff">&mdash; '+esc(signoff)+'</p>';
    return html;
  }

  // ───────────────────────── TV ─────────────────────────

  function panelTier(dp){
    dp=String(dp||'').toLowerCase();
    if(I(dp,'qd-oled')||I(dp,'qd oled')||I(dp,'qdoled'))return 'qdoled';
    if(I(dp,'mla')||I(dp,'meta')||I(dp,'micro lens'))return 'mla';
    if(I(dp,'oled evo'))return 'oledevo';
    if(I(dp,'master oled'))return 'oledevo';
    if(I(dp,'oled'))return 'oled';
    if(I(dp,'micro led')||I(dp,'microled')||I(dp,'micro-led'))return 'microled';
    if(I(dp,'neo qled')||I(dp,'neoqled'))return 'neoqled';
    if(I(dp,'mini'))return 'miniled';
    if(I(dp,'qled'))return 'qled';
    if(I(dp,'nanocell')||I(dp,'nano cell'))return 'nanocell';
    if(I(dp,'uled'))return 'uled';
    if(I(dp,'led')||I(dp,'lcd'))return 'led';
    return '';
  }
  function hdrTier(hd){
    hd=String(hd||'').toLowerCase();
    if(I(hd,'dolby')&&I(hd,'10+'))return 'both';
    if(I(hd,'iq'))return 'dolbyiq';
    if(I(hd,'dolby'))return 'dolby';
    if(I(hd,'10+'))return 'hdrplus';
    if(I(hd,'hdr10'))return 'hdr10';
    if(I(hd,'hlg'))return 'hlg';
    return 'none';
  }
  function platTier(pl){
    pl=String(pl||'').toLowerCase();
    if(I(pl,'webos'))return 'webos';
    if(I(pl,'tizen'))return 'tizen';
    if(I(pl,'google tv'))return 'googletv';
    if(I(pl,'fire'))return 'firetv';
    if(I(pl,'roku'))return 'roku';
    if(I(pl,'vidaa'))return 'vidaa';
    return 'generic';
  }

  function renderTV(s){
    var sz=N(s['screen size']||s['size']),
        rs=String(s['resolution']||'').toUpperCase(),
        dp=s['display type']||s['display']||s['panel']||'',
        rf=N(s['refresh rate']||s['refresh']),
        hd=String(s['hdr format']||s['hdr']||'').toLowerCase(),
        pl=String(s['smart platform']||s['platform']||s['operating system']||s['os']||'').toLowerCase();

    var pt=panelTier(dp),ht=hdrTier(hd),plt=platTier(pl),hi=rf>=120,prem=ht==='both'||ht==='dolby'||ht==='dolbyiq'||ht==='hdrplus';
    var emissive=pt==='qdoled'||pt==='mla'||pt==='oledevo'||pt==='oled'||pt==='microled';
    var P=sz>=20?'This '+sz+'"':'This TV',is4kPlus=I(rs,'4K')||I(rs,'8K')||I(rs,'UHD');

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    // Verdict
    if (pt==='qdoled') verdict = pick([P+" QD-OLED hits OLED blacks AND QLED brightness in the same panel. Best of both, no compromise.", "Big QD-OLED. "+P+" is the panel the industry's been chasing for a decade. Buy it."]);
    else if (pt==='mla'||pt==='oledevo') verdict = pick([P+" OLED evo is the brighter flavor of OLED. Looks incredible in any room, sun-blasted or pitch-black.", "OLED evo at "+rf+"Hz with "+(prem?'Dolby-tier':'')+" HDR — criminal not to buy this."]);
    else if (pt==='oled' && hi && prem) verdict = pick([P+" OLED is a weapon. Motion like silk, blacks like a void, HDR that punches.", "The spec sheet on "+P+" OLED is basically perfect. Done shopping."]);
    else if (pt==='oled') verdict = P+" OLED punches above its weight on picture quality alone.";
    else if (pt==='microled') verdict = "Micro LED. "+P+". Top-of-the-mountain tech — OLED contrast, no burn-in, no brightness ceiling.";
    else if ((pt==='neoqled'||pt==='miniled') && hi && prem) verdict = pick([P+" Mini-LED with full-array dimming and high refresh — sunny living rooms with no compromise.", "Bright, sharp, fast. "+P+" Mini-LED isn't trying to be OLED — it's the right call for bright rooms."]);
    else if (pt==='neoqled'||pt==='miniled') verdict = P+" Mini-LED is the bright-room TV. Sunlight doesn't faze it.";
    else if (pt==='qled') verdict = P+" QLED is the workhorse. Bright, colorful, sports-friendly.";
    else if (pt==='led' && is4kPlus && hi) verdict = P+" 4K with smooth motion is a real value pick. Skip the badge wars.";
    else if (pt==='led') verdict = P+" is the everyday TV. Plug it in, stop overthinking.";
    else verdict = P+" is a solid all-around pick.";

    // Pros
    if (emissive) pros.push("Self-lit pixels = perfect blacks. No backlight glow, no halo.");
    if (pt==='qdoled') pros.push("QD-OLED: OLED contrast plus QLED-level brightness. Best of both.");
    if (pt==='mla'||pt==='oledevo') pros.push("OLED evo: brighter than standard OLED, won't cave in a sunny room.");
    if (pt==='neoqled'||pt==='miniled') pros.push("Mini-LED dimming zones = sharp local contrast without OLED's burn-in worry.");
    if (rf>=144) pros.push(rf+"Hz native — overkill for movies, godsend for PC gamers.");
    else if (rf>=120) pros.push("120Hz refresh — smooth motion for sports and console gaming.");
    if (ht==='both') pros.push("Dolby Vision AND HDR10+. Whatever the streaming app does, you're covered.");
    else if (ht==='dolby'||ht==='dolbyiq') pros.push("Dolby Vision IQ adapts the picture to your room's lighting. Fancy and actually useful.");
    else if (ht==='hdrplus') pros.push("HDR10+ scene-by-scene tone-mapping — Samsung's answer to Dolby Vision.");
    if (plt==='webos'||plt==='tizen'||plt==='googletv') pros.push("Smart OS is fast, has every app you actually use, no Roku-stick needed.");
    if (sz>=75) pros.push(sz+'" is genuinely cinematic. Couch becomes the best seat in the neighborhood.');
    while (pros.length<3) pros.push("4K with proper HDR is the floor in 2025 — this clears it.");

    // Cons
    if (emissive && sz>=65) cons.push("OLED can dim slightly with sustained bright content (CNN logo on for 8 hours). Modern panels handle it but worth knowing.");
    if (emissive) cons.push("OLED in a sun-blasted living room with no curtains is doable but not its sweet spot. Dim or shaded rooms are where it shines.");
    if (pt==='qled' || pt==='neoqled' || pt==='miniled') cons.push("In a fully dark room, blacks won't be quite as inky as OLED — you'll see slight backlight glow on starfield scenes.");
    if (rf<120 && pt!=='oled' && pt!=='oledevo') cons.push("60Hz refresh is fine for movies and casual viewing — heavy gamers will want a dedicated gaming monitor.");
    if (plt==='roku' || plt==='firetv') cons.push("Smart OS is decent but ad-heavier than webOS or Tizen. Some folks like that, some don't.");
    if (cons.length===0) cons.push("Honestly hard to fault at this spec/price. Just confirm the size fits the wall.");

    // Who
    if (emissive && hi && prem) who = "<strong>Built for:</strong> home-theater nerds, console gamers, and people who cancel plans to watch movies properly.";
    else if (pt==='qdoled' || pt==='mla' || pt==='microled') who = "<strong>Built for:</strong> picture-quality obsessives. You already know why you want this.";
    else if (pt==='neoqled'||pt==='miniled') who = "<strong>Built for:</strong> bright-room watchers and sports fans who want flagship feel without OLED's quirks.";
    else if (pt==='qled') who = "<strong>Built for:</strong> living rooms with windows, sports families, and casual viewers.";
    else who = "<strong>Built for:</strong> anyone who wants a solid everyday TV without overthinking.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── HEADPHONE ─────────────────────────

  function renderHeadphone(s){
    var ff=String(s['form factor']||'').toLowerCase(),
        anc=String(s['anc']||s['noise canceling']||'').toLowerCase(),
        bat=s['battery']||s['battery life']||'',
        conn=String(s['connectivity']||'').toLowerCase(),
        bn=N(bat);

    var overEar=I(ff,'over'), inEar=I(ff,'in-ear')||I(ff,'in ear'), onEar=I(ff,'on-ear')||I(ff,'on ear');
    var hasANC=I(anc,'anc')||I(anc,'noise')||I(anc,'adaptive'), wireless=I(conn,'bluetooth')||I(conn,'wireless');

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (hasANC && bn>=30 && overEar) verdict = pick([
      "Adaptive ANC. "+(bat||'')+" of playback. Bluetooth multipoint. Sony brought a knife to a gunfight and the gun was already on its knees.",
      "Over-ear ANC done right. "+(bat||'30 hours')+" of battery means you'll forget chargers exist. Train, plane, open office — they handle all of it."
    ]);
    else if (hasANC && overEar) verdict = pick([
      "Over-ear adaptive ANC for the daily commute. Battery's healthy, comfort is the headline. Pair with phone + laptop and forget about them.",
      "These do the boring stuff well: ANC, battery, comfort, multipoint. Boring is what you want in headphones you wear all day."
    ]);
    else if (hasANC && inEar) verdict = "In-ear ANC that disappears in your ears. "+(bat||'')+" between charges. The right pick for gym, runs, and plane seats with zero room for over-ears.";
    else if (overEar) verdict = "Over-ear comfort for long sessions. The classic at-home / desk-listening pick.";
    else if (inEar) verdict = "In-ear convenience. Pocket-friendly, gym-friendly, train-friendly.";
    else verdict = "Solid wireless headphones. Pair, charge, listen.";

    if (hasANC) pros.push("Adaptive ANC reads the room and tunes itself in real time — train, plane, open office.");
    if (bn>=30) pros.push(bat+" of playback. Forget chargers exist for a week.");
    else if (bn>=20) pros.push(bat+" battery covers a long-haul flight + a couple commutes on one charge.");
    if (I(conn,'multipoint') || I(conn,'bluetooth')) pros.push("Bluetooth multipoint — phone and laptop both stay paired at the same time.");
    if (I(conn,'3.5')) pros.push("3.5mm wired fallback for when the battery runs out or the airline insists.");
    if (overEar) pros.push("Over-ear shape blocks more passive noise even before ANC kicks in.");
    if (inEar) pros.push("Tiny case, zero pocket footprint. Toss it in any bag.");
    while (pros.length<3) pros.push("Clean Bluetooth pairing across devices — no fiddling.");

    if (hasANC && overEar) cons.push("Over-ear ANC leaks a bit at top volume on a quiet train — neighbors might hear bass-heavy tracks.");
    if (overEar) cons.push("Over-ear shape isn't gym-friendly — they'll slide on a treadmill run.");
    if (inEar) cons.push("In-ear tips wear out — keep a backup set in the case.");
    if (hasANC) cons.push("Touch controls take a week of muscle memory. After that, fluent.");
    cons.push("App pushes firmware notifications. Disable if you don't want pings.");

    if (overEar && hasANC) who = "<strong>Built for:</strong> commuters, remote workers, and audio nerds who want flagship ANC + comfort without going wired hi-fi.";
    else if (inEar) who = "<strong>Built for:</strong> runners, gym-goers, and travel-light commuters.";
    else who = "<strong>Built for:</strong> daily listeners who want clean wireless audio and don't want to think about it.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── SOUNDBAR ─────────────────────────

  function renderSoundbar(s){
    var ch=String(s['channels']||s['audio channels']||'').toLowerCase(),
        atmos=String(s['dolby atmos']||s['atmos']||'').toLowerCase(),
        sub=String(s['subwoofer']||'').toLowerCase(),
        hdmi=String(s['hdmi']||s['hdmi/earc']||s['hdmi / earc']||'').toLowerCase();

    var heightCh=I(ch,'.4')||I(ch,'.2'), bigChannels=I(ch,'7.')||I(ch,'9.')||I(ch,'11.'),
        hasAtmos=I(atmos,'yes'), wirelessSub=I(sub,'wireless'), wirelessRears=I(sub,'rear');

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (bigChannels && hasAtmos && wirelessRears) verdict = pick([
      ch.toUpperCase()+" channels with wireless rears AND a sub. The closest you'll get to a real Atmos theater without speaker wire in the walls.",
      "This is a one-box theater. "+ch.toUpperCase()+" channels, real height drivers, wireless rears. Run the eARC cable and you're done."
    ]);
    else if (heightCh && hasAtmos) verdict = pick([
      ch.toUpperCase()+" with up-firing Atmos drivers. Real overhead audio without ceiling speakers — bounces off your ceiling and lands above the couch.",
      "Up-firing Atmos for actual height channels, not virtualized fakery. The detail in mixed-down theatrical audio jumps."
    ]);
    else if (hasAtmos) verdict = "Compact Atmos soundbar. Beats your TV speakers by an order of magnitude — and you don't need a center channel cabinet.";
    else verdict = ch.toUpperCase()+" soundbar. The dialogue-clarity / floor-shaking-bass upgrade your TV speakers can't deliver.";

    if (heightCh) pros.push("Up-firing Atmos drivers — real overhead height, not virtualized. Mixing engineers can tell.");
    if (wirelessRears) pros.push("Wireless rear speakers — no cable runs across the floor. Plug, pair, done.");
    if (wirelessSub && !wirelessRears) pros.push("Wireless subwoofer — place it anywhere within ~25 ft, no cable.");
    if (I(hdmi,'earc')) pros.push("HDMI eARC pass-through preserves Atmos and DTS:X — no compromise on streaming or disc.");
    pros.push("Q-Symphony / TV-stage extension lets your TV speakers ADD to the bar instead of getting muted.");
    if (bigChannels) pros.push(ch.toUpperCase()+" channels means every action movie shootout sounds like a different room.");
    while (pros.length<3) pros.push("Setup mics auto-calibrate to your room — pop them in, listen, you're done.");

    if (wirelessSub) cons.push("Wireless sub still needs a power outlet — 'wireless' = no audio cable, but the wall warts add up.");
    if (heightCh) cons.push("Atmos up-firing drivers need a flat ~8\" ceiling to bounce properly. Vaulted ceilings: less effective.");
    if (wirelessRears) cons.push("Wireless rears need outlets near the back of the room. Plan your power.");
    cons.push("eARC support requires a fairly recent TV — check for HDMI 2.1 and eARC label before buying.");
    cons.push("Setup with calibration mics takes ~30 minutes the first time — worth doing properly.");

    if (bigChannels && wirelessRears) who = "<strong>Built for:</strong> living rooms with movie habits and the patience for real surround.";
    else if (heightCh) who = "<strong>Built for:</strong> people upgrading from TV speakers who want Atmos without a full receiver setup.";
    else who = "<strong>Built for:</strong> anyone who's tired of straining to hear dialogue. The single biggest TV upgrade after the panel.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── HOME THEATER ─────────────────────────

  function renderHomeTheater(s){
    var ch=String(s['channels']||s['audio channels']||'').toLowerCase(),
        pwr=s['total power']||'',
        atmos=String(s['dolby atmos']||s['atmos']||'').toLowerCase();

    var heightCh=I(ch,'.4')||I(ch,'.2'), hasAtmos=I(atmos,'yes'), pwrN=N(pwr);

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (pwrN>=500 && hasAtmos) verdict = pick([
      pwr+" of power across "+ch.toUpperCase()+" channels. The home theater rig that doesn't take a weekend to install.",
      "A real home theater you can set up in an hour. "+ch.toUpperCase()+" with full Atmos — no AV receiver, no speaker wire chase."
    ]);
    else if (hasAtmos) verdict = "Atmos-capable home theater system. Theater sound without an installer.";
    else verdict = ch.toUpperCase()+" home theater system. Full surround in a setup that doesn't need a contractor.";

    pros.push("No AV receiver needed — everything's pre-balanced for the speakers in the box.");
    if (hasAtmos) pros.push("Real Dolby Atmos with up-firing or rear height channels. Theater-grade audio.");
    pros.push("Plug HDMI eARC into the TV and you're 90% done. Optional wireless rears finish the job.");
    if (pwrN>=400) pros.push(pwr+" of headroom — won't strain at theater-volume action scenes.");
    pros.push("Calibration mic dials in your room geometry. Auto-EQ takes 5 minutes.");

    cons.push("One-box systems don't quite match dedicated separates if you have a true theater room. For 95% of living rooms, doesn't matter.");
    cons.push("Subwoofer placement matters — corners help, but not too tight or it booms.");
    cons.push("Volume calibration takes a few rounds — auto-EQ is good, not perfect.");
    cons.push("If you change rooms, plan to recalibrate. The room IS the speaker.");

    who = "<strong>Built for:</strong> people who want real theater sound but don't want to pay an installer or read a 200-page AV-receiver manual.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── PROJECTOR ─────────────────────────

  function renderProjector(s){
    var br=s['brightness']||'',
        rs=String(s['resolution']||'').toUpperCase(),
        thr=String(s['throw']||s['throw type']||'').toLowerCase(),
        src=String(s['light source']||s['source']||'').toLowerCase(),
        brN=N(br);

    var laser=I(src,'laser'), led=I(src,'led'), lamp=I(src,'lamp'),
        is4k=I(rs,'4K')||I(rs,'UHD'), is1080=I(rs,'1080')||I(rs,'FHD')||I(rs,'FULL HD'),
        ust=I(thr,'ultra'), short=I(thr,'short')&&!ust, long=I(thr,'long');

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (ust && is4k) verdict = "Ultra-short throw 4K projector. Sits inches from the wall and casts 100\". The cabinet replacement for the wall TV.";
    else if (laser && is4k) verdict = "4K laser projector — the lamp-replacement-anxiety era is over. Set it once, forget the bulb.";
    else if (led && brN<300) verdict = pick([
      "Portable LED projector. Auto-everything setup, plug-and-cinema in 4 seconds. Bedroom and dim-room king.",
      br+" lumens means dim rooms only — but for the right room, this is magic. Throw it on a wall, press play."
    ]);
    else if (laser) verdict = "Laser projector with a long usable life. Cinema-grade picture without the lamp anxiety.";
    else if (led) verdict = "LED projector — long-life light source, low power draw, plug-and-go.";
    else verdict = "Projector that does the job. Spec out your room first.";

    if (laser) pros.push("Laser source = 20,000+ hours of usable life. No lamp to replace.");
    if (led) pros.push("LED light source = 30,000+ hours. The light source outlives the projector.");
    if (is4k) pros.push("Native 4K resolution at projector scale. Detail per square inch on a 100\" image is impressive.");
    else if (is1080) pros.push("Full HD 1080p — sharp at any reasonable viewing distance.");
    if (ust) pros.push("Ultra-short throw means the projector lives ~12\" from the wall. No ceiling mount, no shadow when you walk past.");
    if (short) pros.push("Short throw — fills a 100\" image from ~5 ft away. Friendly to small living rooms.");
    if (brN>=2000) pros.push(br+" of brightness handles ambient light without complaint.");
    if (brN<500 && led) pros.push("Tiny + portable. Travels with you. Not a permanent install commitment.");
    pros.push("Streaming apps built in (or HDMI from your stick of choice). Smart projector beats 'dumb projector + laptop' every time.");

    if (brN<500) cons.push(br+" lumens is dim-room only. Don't expect daytime viewing in a sunlit room.");
    if (lamp) cons.push("Lamp source has finite life — plan to swap the bulb at ~5,000 hours of use.");
    if (long) cons.push("Long throw needs a real distance from screen to projector — small rooms struggle.");
    cons.push("Audio is OK but never a replacement for a soundbar or proper speakers — pair Bluetooth audio.");
    cons.push("Auto-keystone and auto-focus are great but not perfect — fine-tune for the best picture.");

    if (ust) who = "<strong>Built for:</strong> wall-TV alternative seekers and people who don't want to ceiling-mount.";
    else if (brN<500 && led) who = "<strong>Built for:</strong> renters, dorm rooms, backyard movie nights, and kids who want a giant Switch screen.";
    else if (is4k && laser) who = "<strong>Built for:</strong> dedicated theater rooms and people who want a real cinema setup at home.";
    else who = "<strong>Built for:</strong> people who want a 100\" screen without paying TV money for it.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── CAMERA ─────────────────────────

  function renderCamera(s){
    var mp=N(s['megapixels']||s['mp']),
        sensor=String(s['sensor']||s['sensor size']||'').toLowerCase(),
        vid=String(s['max video']||s['video']||'').toUpperCase(),
        mount=String(s['lens mount']||s['mount']||'').toLowerCase();
    var ff=I(sensor,'full frame')||I(sensor,'full-frame'),
        apsc=I(sensor,'aps-c')||I(sensor,'apsc'),
        m43=I(sensor,'micro four')||I(sensor,'m4/3')||I(sensor,'m43'),
        is8k=I(vid,'8K'), is4k=I(vid,'4K'), is60p=I(vid,'60');

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (ff && is8k) verdict = "Full-frame 8K video monster. The pro-tier hybrid for stills and cinema.";
    else if (ff) verdict = "Full-frame body. Big sensor = shallow depth of field, low-light gracefulness, and color depth that lifts every shot.";
    else if (apsc) verdict = "APS-C camera — the sweet spot of size, price, and image quality. Great for beginners and intermediates.";
    else if (m43) verdict = "Micro Four Thirds — small body, small lenses, surprisingly capable.";
    else verdict = "Camera that hits its specs without drama.";

    if (ff) pros.push("Full-frame sensor pulls in more light, gives shallower bokeh, and looks pro out-of-camera.");
    if (apsc) pros.push("APS-C body weighs less, costs less, and doesn't sacrifice image quality for the upgrade-curious.");
    if (mp>=24) pros.push(mp+" megapixels is the modern sweet spot — big enough to crop, small enough not to fill drives.");
    if (is8k) pros.push("8K video at "+vid+" — futureproof for 4K final delivery via supersampling.");
    else if (is4k) pros.push("4K video"+(is60p?" at 60p":"")+" — broadcast-ready for YouTube, streaming, even some commercial work.");
    if (mount) pros.push("Mount: "+mount+". Decade of glass available — first-party and third-party alike.");
    pros.push("In-body image stabilization (IBIS) means handheld shots don't look like you had four espressos.");

    if (ff) cons.push("Full-frame lenses are expensive — budget for at least 2-3 lenses on top of the body.");
    cons.push("Battery life is tight on mirrorless — bring 2-3 batteries for a wedding or all-day shoot.");
    if (is8k) cons.push("8K video files are massive. Plan for fast SSDs and beefy editing storage.");
    cons.push("Autofocus systems shine in good light, hunt slightly in low light — stay mindful.");

    if (ff) who = "<strong>Built for:</strong> serious hobbyists, professionals, and creators who care about light-gathering and color depth.";
    else if (apsc) who = "<strong>Built for:</strong> upgrading from phones, weekend hobbyists, and travel shooters.";
    else who = "<strong>Built for:</strong> photographers and creators with specific lens-system loyalty.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── KITCHEN (one shared voice) ─────────────────────────

  function renderKitchen(s, cat){
    var cap=s['capacity']||'',
        wat=s['wattage']||'',
        capN=N(cap), watN=N(wat);

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (cat==='air_fryer') verdict = cap+" air fryer at "+wat+". Counter-friendly and big enough for a family of four. Crispy without the oil mess.";
    else if (cat==='coffee_maker') verdict = cap+" coffee maker. Wakes you up in the morning, refills you at noon, doesn't argue.";
    else if (cat==='blender') verdict = wat+" blender. Smoothies, soups, frozen drinks — chops through ice without hesitation.";
    else if (cat==='microwave') verdict = cap+" microwave at "+wat+". The everyday workhorse.";
    else if (cat==='refrigerator') verdict = cap+" fridge — the right size for a 3-4 person household.";
    else if (cat==='stand_mixer') verdict = cap+" bowl, "+wat+" motor. Bake sourdough, bread, pasta, and not break a sweat.";
    else verdict = "Kitchen workhorse. Does the job, gets out of the way.";

    if (capN>0) pros.push(cap+" capacity is the right size for most weeknight cooking.");
    if (watN>=1500) pros.push(wat+" of power means it preheats fast and handles dense ingredients.");
    pros.push("Presets do the thinking — but knob-controllable when you want it.");
    if (s['programmable']) pros.push("App-enabled — schedule it, monitor it, walk away.");
    if (s['energy star']) pros.push("Energy Star certified — meaningful difference on a high-use appliance.");

    cons.push("Counter footprint is real — measure twice before buying.");
    if (watN>=1500) cons.push("High-wattage appliances + GFCI kitchen circuits don't always play nice. Test the outlet first.");
    cons.push("Cleaning is the chore most people forget to factor in. Read the manual.");

    who = "<strong>Built for:</strong> daily cooks who want the right size + the right power for their kitchen.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── MONITOR ─────────────────────────

  function renderMonitor(s){
    var sz=N(s['panel size']||s['size']),
        rs=String(s['resolution']||'').toUpperCase(),
        rf=N(s['refresh rate']||s['refresh']),
        pt=String(s['panel type']||s['panel']||'').toLowerCase();

    var verdict, pros=[], cons=[], who, so=pick(SIGNOFFS);

    if (rf>=240 && I(pt,'oled')) verdict = sz+'" OLED at '+rf+'Hz. The competitive-gamer endgame. Per-pixel response time + true black.';
    else if (rf>=144) verdict = sz+'" '+rf+'Hz monitor. Smooth, fast, and the right call for serious gaming.';
    else verdict = sz+'" '+rs+' monitor — productivity-grade or casual gaming.';

    if (rf>=144) pros.push(rf+'Hz refresh — every frame counts in shooters, and even the desktop feels different.');
    if (I(pt,'oled')) pros.push('OLED panel: per-pixel contrast, near-instant response.');
    if (I(pt,'ips')) pros.push('IPS panel: wide viewing angles, color accuracy. Good for design + content creation.');
    if (I(rs,'4K')||I(rs,'UHD')) pros.push('4K resolution — pixel density at desk distance is unreal.');
    pros.push('Dual-input ports: connect work laptop + gaming rig, swap with one button.');

    cons.push('OLED text fringing on tiny fonts — readable but worth knowing if you stare at code.');
    cons.push('Calibration matters more on monitors than TVs — invest in a colorimeter if you do design work.');

    who = "<strong>Built for:</strong> gamers, creators, and remote workers who spend 8+ hours in front of a screen.";

    return shell(verdict,pros,cons,who,so);
  }

  // ───────────────────────── DISPATCHER ─────────────────────────

  function render(specs){
    var cat = detectCategory(specs);
    if (cat === 'headphone')   return renderHeadphone(specs);
    if (cat === 'soundbar')    return renderSoundbar(specs);
    if (cat === 'home_theater')return renderHomeTheater(specs);
    if (cat === 'projector')   return renderProjector(specs);
    if (cat === 'camera')      return renderCamera(specs);
    if (cat === 'monitor')     return renderMonitor(specs);
    if (cat === 'air_fryer' || cat === 'coffee_maker' || cat === 'blender' ||
        cat === 'microwave'  || cat === 'refrigerator' || cat === 'stand_mixer' ||
        cat === 'kitchen')    return renderKitchen(specs, cat);
    return renderTV(specs);
  }

  // ───────────────────────── WIRE / BOOT ─────────────────────────

  function wire(wrap){
    if (wrap.__txBound) return; wrap.__txBound = 1;
    var gridId = wrap.getAttribute('data-grid-id'),
        summaryId = wrap.getAttribute('data-summary-id'),
        bt = wrap.querySelector('.pdp__translate-btn'),
        su = document.getElementById(summaryId);
    if (!bt || !su) return;
    bt.addEventListener('click', function(){
      var t = bt.querySelector('.pdp__translate-btn-text');
      if (su.classList.contains('show')) {
        su.classList.remove('show'); su.hidden = !0;
        bt.setAttribute('aria-expanded', 'false');
        if (t) t.textContent = 'Translate this spec gibberish';
        return;
      }
      su.innerHTML = render(readSpecs(gridId));
      su.hidden = !1; su.classList.add('show');
      bt.setAttribute('aria-expanded', 'true');
      if (t) t.textContent = 'Hide translation';
    });
  }

  function boot(){
    document.querySelectorAll('[data-translate-root]').forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
